import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_4 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_5 = { class: "col-sm-8" }
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_8 = { class: "col-sm-8" }
const _hoisted_9 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_10 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_11 = { class: "col-sm-8" }
const _hoisted_12 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_13 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_14 = { class: "col-sm-8" }
const _hoisted_15 = {
  key: 3,
  class: "row mt-2"
}
const _hoisted_16 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_17 = { class: "col-sm-8" }
const _hoisted_18 = {
  key: 4,
  class: "row mt-2"
}
const _hoisted_19 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_20 = { class: "col-sm-8" }
const _hoisted_21 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_22 = {
  key: 5,
  class: "row mt-2"
}
const _hoisted_23 = { class: "col-sm-8" }
const _hoisted_24 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.form.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.helper.trans("labels.trader")) + ":", 1),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`traderId`)
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_TraderMultiselect, {
                      class: _normalizeClass(parentProps.class),
                      modelValue: _ctx.form.trader,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.trader) = $event)),
                      multiple: false,
                      disabled: !!_ctx.form.id
                    }, null, 8, ["class", "modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.helper.trans("labels.plan_type")) + ":", 1),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`planType`)
            }, {
              default: _withCtx((parentProps) => [
                _createVNode(_component_Multiselect, {
                  class: _normalizeClass(parentProps.class),
                  modelValue: _ctx.form.planType,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.planType) = $event)),
                    _ctx.onPlanTypeChange
                  ],
                  options: ['limit', 'timer'],
                  "custom-label": (opt) => _ctx.helper.trans(`payout_plans.plan_type.${opt}`),
                  multiple: false,
                  "select-label": "Select",
                  placeholder: ""
                }, null, 8, ["class", "modelValue", "custom-label", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        (_ctx.form.planType === 'limit')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.helper.trans("labels.limit_amount")) + ":", 1),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`limitAmount`)
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.limitAmount) = $event)),
                      type: "text",
                      id: "limitAmount"
                    }, null, 2), [
                      [_vModelText, _ctx.form.limitAmount]
                    ])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.form.planType === 'limit')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.helper.trans("labels.limit_currency")) + ":", 1),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`limitCurrency`)
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_Multiselect, {
                      class: _normalizeClass(parentProps.class),
                      modelValue: _ctx.form.limitCurrency,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.limitCurrency) = $event)),
                      options: _ctx.store.getters['currencyMethods/currencies'],
                      "custom-label": (opt) => `${opt}`,
                      multiple: false,
                      "select-label": "Select",
                      placeholder: ""
                    }, null, 8, ["class", "modelValue", "options", "custom-label"])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.form.planType === 'limit')
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.helper.trans("labels.count_mode")) + ":", 1),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`countMode`)
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_Multiselect, {
                      class: _normalizeClass(parentProps.class),
                      modelValue: _ctx.form.countMode,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.countMode) = $event)),
                      options: ['all_deals', 'only_success'],
                      "custom-label": (opt) => _ctx.helper.trans(`payout_plans.count_mode.${opt}`),
                      multiple: false,
                      "select-label": "Select",
                      placeholder: ""
                    }, null, 8, ["class", "modelValue", "custom-label"])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.form.planType === 'timer')
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.helper.trans("labels.timer_interval")) + ":", 1),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`expiredAtManual`)
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_DatePicker, {
                      class: _normalizeClass(parentProps.class),
                      modelValue: _ctx.form.expiredAtManual,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.expiredAtManual) = $event)),
                      mode: "dateTime",
                      "model-modifiers": {string: true},
                      is24hr: "",
                      masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                    }, {
                      default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                        _createElementVNode("input", {
                          class: "form-control",
                          placeholder: _ctx.helper.trans('labels.timer_interval'),
                          value: inputValue,
                          onFocus: togglePopover,
                          onChange: inputEvents.change
                        }, null, 40, _hoisted_21)
                      ]),
                      _: 2
                    }, 1032, ["class", "modelValue"])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.form.planType === 'timer')
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-sm-4" }, null, -1)),
              _createElementVNode("div", _hoisted_23, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quickPresets, (preset) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: preset.id,
                    onClick: _withModifiers(($event: any) => (_ctx.applyPreset(preset)), ["prevent"]),
                    type: "button",
                    class: "btn btn-sm btn-outline-secondary me-2 mb-2"
                  }, _toDisplayString(_ctx.presetLabel(preset)), 9, _hoisted_24))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}